import React from "react";
import { ComponentWithAs, Icon, IconProps } from "@chakra-ui/react";

const IconComp: ComponentWithAs<"svg", IconProps> = ({
  children,
  ...props
}) => {
  return (
    <Icon {...props}>
      <path d="m479.933 100.881-100.466-100.881-347.4 348.837v100.814h100.533zm-319.525 278.34-58.134-58.375 196.684-197.498 58.134 58.374zm277.193-278.34-59.343 59.588-58.134-58.374 59.343-59.589zm-375.534 318.781v-58.442l19.041-19.12 58.134 58.375-19.109 19.188h-58.066z" />
      <path d="m32.067 482.011h447.85v29.989h-447.85z" />
      <path d="m237.768 419.662h242.149v29.989h-242.149z" />
    </Icon>
  );
};
IconComp.defaultProps = {
  viewBox: "0 0 512 512",
  boxSize: "20px",
};

export default IconComp;
